export default __webpack_public_path__ + "static/media/pp.bf35333f.jpg";